import {
  Input,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  Button,
  Switch,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";

function ExampleList2() {
  const { register, handleSubmit, setValue } = useForm();
  const navigate = useNavigate();

  const [isSecondSwitchOn, setIsSecondSwitchOn] = useState(false);

  const location = useLocation();

  const onSubmit = (data) => {
    navigate("/example3", { state: { jobdetails1 : location.state, jobdetails2: data } });
  };

  return (
    <div>
      <div className=" text-left sm:max-w-5xl sm:mx-auto my-10">
        <form className="" onSubmit={handleSubmit(onSubmit)}>
          <div className="max-w-xl mx-4 flex-col">
            <h4>A Few more details</h4>
            <div className="my-5">
              <Text className="text-black font-semibold " mb="16px">
                Upload CV ?
              </Text>
              <RadioGroup
                {...register("upload_cv")}
                onChange={(value) => {
                  const isJoiningAmountRequired = value === "1";
                  setValue("upload_cv", isJoiningAmountRequired);
                }}
              >
                <Stack direction="row">
                  <Radio value="1">Yes</Radio>
                  <Radio value="2">No</Radio>
                </Stack>
              </RadioGroup>
            </div>
            <div className="my-5">
              <Text className="text-black font-semibold" mb="8px">
                Deadline for this job:
              </Text>
              <input
                type="date"
                className="cursor-pointer"
                id="start"
                name="trip-start"
                {...register("job_deadline")}
                onChange={(e) => {
                  const selectedDate = new Date(e.target.value);
                  const formattedDate = selectedDate
                    .toISOString()
                    .split("T")[0];
                  e.target.value = formattedDate;
                }}
              />
            </div>
            <div className="my-5">
              <Text className="text-black font-semibold " mb="16px">
                Required Skills :
              </Text>
            </div>
            <div>
              <Text className="text-black font-semibold " mb="16px">
                Minimum Education :
              </Text>

              <Select
                className="border-black"
                variant="outline"
                defaultChecked=""
                {...register("")}
              >
                <option value="option1">Secondary Education</option>
                <option value="option2">Under Graduate</option>
                <option value="option3">Graduate</option>
                <option value="option4">PhD</option>
              </Select>
            </div>
            <div className="my-5">
              <Text className="text-black font-semibold " mb="16px">
                Total Experience Required (Years):
              </Text>

              <div className="flex gap-2">
                <div className="mt-2 w-1/2">
                  <Text className="text-black font-semibold" mb="8px">
                    Minimum <span className="text-red-950">*</span>:
                  </Text>
                  <Select
                    className="border-black"
                    variant="outline"
                    defaultChecked=""
                    {...register("min_job_exp")}
                  >
                    <option value="option1">Fresher</option>
                    <option value="option2">1</option>
                    <option value="option3">2</option>
                    <option value="option4">3</option>
                    <option value="option5">4</option>
                    <option value="option6">5</option>
                  </Select>
                </div>
                <div className="mt-2 w-1/2">
                  <Text className="text-black font-semibold" mb="8px">
                    Maximum <span className="text-red-950">*</span>:
                  </Text>
                  <Select
                    className="border-black"
                    variant="outline"
                    defaultChecked=""
                    {...register("max_job_exp")}
                  >
                    <option value="option1">1</option>
                    <option value="option2">2</option>
                    <option value="option3">3</option>
                    <option value="option4">4</option>
                    <option value="option5">5</option>
                    <option value="option6">6</option>
                  </Select>
                </div>
              </div>
            </div>
            <div className="my-5">
              <Text className="text-black font-semibold " mb="16px">
                Type of Interview? :
              </Text>
              <RadioGroup
                {...register("interview_type")}
                onChange={(value) => {
                  const interviewType =
                    value === "2"
                      ? "Telephonic / Online Interview"
                      : "In-Person / Walk-in Interview";
                  setValue("interview_type", interviewType);
                }}
              >
                <Stack direction="row">
                  <Radio value="1">In-Person / Walk-in Interview</Radio>
                  <Radio value="2">Telephonic / Online Interview</Radio>
                </Stack>
              </RadioGroup>
            </div>
            <div>
              <Text className="text-black font-semibold " mb="16px">
                Do you want candidates to contact you? :
              </Text>
              <Select
                className="border-black"
                variant="outline"
                defaultChecked=""
                {...register("candidate_contact_via")}
              >
                <option value="option1">Yes, by Call</option>
                <option value="option2">Yes, by Email</option>
                <option value="option3">Yes, by Whatsapp</option>
                <option value="option4">No</option>
              </Select>
            </div>
            <div className="flex justify-between my-10">
              <Link to={"/jobDetails1"}>
                <Button colorScheme="blue">
                  <span className="text-2xl mb-1">←</span> Back{" "}
                </Button>
              </Link>
              {/* <Link to={"/jobreview"}> */}
              <Button colorScheme="blue" type="submit">
                Continue <span className="text-2xl mb-1"> →</span>
              </Button>
              {/* </Link> */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ExampleList2;

// import React from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useLocation } from "react-router-dom";

// const JobDetails2 = () => {
//   const { register, handleSubmit } = useForm();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const onSubmit = (data) => {
//     navigate("/jobreview", { state: { ...location.state, jobdetails2: data } });
//   };

//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       <div>
//         <label>Interview Mode</label>
//         <input {...register("interview_mode")} />
//       </div>
//       <div>
//         <label>Preferred Start Date</label>
//         <input {...register("start_date")} />
//       </div>
//       <div>
//         <label>Experience</label>
//         <input {...register("experience")} />
//       </div>
//       <div>
//         <label>Skills</label>
//         <input {...register("skills")} />
//       </div>
//       <div>
//         <label>Availability</label>
//         <input {...register("availability")} />
//       </div>
//       <button type="submit">Review</button>
//     </form>
//   );
// };

// export default JobDetails2;
